(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ambioph-hero"] && !Shopify.designMode) return;
  try {
    
  const addProfessionalMenuLink = () => {
    const menuLists = document.querySelectorAll('.ltn__main-menu > ul, .ltn__utilize-mobile-menu .ltn__utilize-menu > ul');

    menuLists.forEach((menuList) => {
      if (menuList.querySelector('[data-ambioph-professionisti-link]')) return;

      const item = document.createElement('li');
      const link = document.createElement('a');
      const specialItem = menuList.querySelector('li.special-link');

      item.className = 'ambioph-professionisti-menu-item';
      link.href = '/pages/area-professionisti';
      link.textContent = 'Professionisti';
      link.setAttribute('data-ambioph-professionisti-link', 'true');
      item.appendChild(link);

      if (specialItem) {
        menuList.insertBefore(item, specialItem);
      } else {
        menuList.appendChild(item);
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addProfessionalMenuLink, { once: true });
  } else {
    addProfessionalMenuLink();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ambioph-science-video"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('.ambioph-science');

    sections.forEach((section) => {
      if (section.dataset.videoReady === 'true') return;
      section.dataset.videoReady = 'true';

      const dialog = section.querySelector('[data-ambioph-video-dialog]');
      const openers = section.querySelectorAll('[data-ambioph-video-open]');
      const closer = section.querySelector('[data-ambioph-video-close]');
      const iframe = section.querySelector('[data-ambioph-external-video]');

      if (!dialog) return;

      const setExternalSource = () => {
        if (!iframe || iframe.src) return;
        const type = iframe.dataset.videoType;
        const id = iframe.dataset.videoId;

        if (type === 'youtube') {
          iframe.src = `https://www.youtube.com/embed/${id}?autoplay=1&rel=0`;
        } else if (type === 'vimeo') {
          iframe.src = `https://player.vimeo.com/video/${id}?autoplay=1`;
        }
      };

      const openDialog = () => {
        setExternalSource();
        dialog.showModal();
      };

      const closeDialog = () => {
        const video = dialog.querySelector('video');
        if (video) video.pause();
        if (iframe) iframe.src = '';
        dialog.close();
      };

      openers.forEach((opener) => opener.addEventListener('click', openDialog));
      if (closer) closer.addEventListener('click', closeDialog);

      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) closeDialog();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template"]) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-complementary');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
          $('.product-complementary__carousel').slick({
        		speed: 1000,
        		autoplay: false,
        		slidesToShow: 3,
        		adaptiveHeight: true,
        		prevArrow: '<a class="slick-prev"><i class="fas fa-arrow-left" alt="Arrow Icon"></i></a>',
                nextArrow: '<a class="slick-next"><i class="fas fa-arrow-right" alt="Arrow Icon"></i></a>',
        		responsive: [{
        			breakpoint: 992,
        			settings: {
        				slidesToShow: 3
        			}
        		},
        		{
        			breakpoint: 768,
        			settings: {
        				slidesToShow: 2,
        				arrows: true
        			}
        		},
        		{
        			breakpoint: 480,
        			settings: {
        				slidesToShow: 2,
        				arrows: true
        			}
        		}]
        	});
        }
      })
      .catch(e => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-complementary');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-product"]) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;

          $('.ltn__related-product-slider-one-active').slick({
              arrows: true,
              dots: false,
              infinite: true,
              speed: 300,
              slidesToScroll: 1,
              prevArrow: '<a class="slick-prev"><i class="fas fa-arrow-left" alt="Arrow Icon"></i></a>',
              nextArrow: '<a class="slick-next"><i class="fas fa-arrow-right" alt="Arrow Icon"></i></a>'
          });
          
        }
      })
      .catch(e => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();
})();
